import { useState, type ReactNode } from 'react';
import { QueryClientProvider } from '@tanstack/react-query';
import { I18nextProvider } from 'react-i18next';
import { createQueryClient } from '@/lib/query/client';
import { AuthProvider } from '@/lib/auth/AuthProvider';
import { ToastProvider } from '@/lib/ui';
import { TooltipProvider } from '@/lib/ui/Tooltip';
import { MediaPickerHost } from '@/features/media/MediaPickerHost';
import i18n from '@/lib/i18n/config';

/** Single composition root for all app-wide context (plan §3). */
export function Providers({ children }: { children: ReactNode }) {
  const [queryClient] = useState(createQueryClient);
  return (
    <I18nextProvider i18n={i18n}>
      <QueryClientProvider client={queryClient}>
        <ToastProvider>
          <TooltipProvider>
            <AuthProvider>
              <MediaPickerHost>{children}</MediaPickerHost>
            </AuthProvider>
          </TooltipProvider>
        </ToastProvider>
      </QueryClientProvider>
    </I18nextProvider>
  );
}
